import { Component, HostListener, Input, OnInit, ViewChild } from "@angular/core";
import {
  isUndefined,
  onlyAphaNumeric,
  spaceToHyphen,
  stringToNumber,
  toBoolean,
} from "src/app/services/codeUtils";
import { ConfigService } from "src/app/services/config/config.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { WebcontentService } from "src/app/services/webcontent/webcontent.service";
import { Navigator } from "../../menu/navigator";
import { GamesService } from "src/app/services/lobby/games.service";
import { ScrollService } from "src/app/services/scroll/scroll.service";
import { LobbyStateService } from "src/app/services/lobbyState/lobby-state.service";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { EventsService } from "src/app/services/event/event.service";
import { IonInfiniteScroll, Platform } from "@ionic/angular";
import { Subscription } from "rxjs";
import { LoadingController } from "@ionic/angular";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { LobbyApiService } from "src/app/services/lobby/lobby.api.service";
@Component({
  selector: "app-gallery-casino",
  templateUrl: "./gallery-casino.component.html",
  styleUrls: ["./gallery-casino.component.scss"]
})
export class GalleryCasinoComponent implements OnInit {
  @Input() showLastPlayed: boolean;
  @Input() customerLevel: number;
  @Input() isMobileWeb: boolean;
  @Input() LastPlayedGamesPresent: boolean;
  @Input() isMobileApp: boolean;
  autoLoadBatchTime: number;



  // Adjust the page size and infinite scroll threshold dynamically
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.adjustPageSizeAndThreshold();
    this.autoLoadAllBatches();
  }

  public isAuthenticated: boolean;
  public pageSizeSet = 25;
  public mobileGamesSize = 20;
  public pageSize: number = this.pageSizeSet;
  public imagesPath: string;
  public isfavourite = false;
  public filteredCasinoGames: Array<any> = [];
  public mobileCasinoGames: any = null;
  public selectedItem: string;
  public allGamesLoaded = false;
  public mobileGameCounter = 1;
  public showLDInFavTab: boolean = false;
  public showSwimLanes: boolean;
  public FEATURE_VENDOR_DEMO: any;
  public isTop: boolean = this.config.getConfig().FEATURE_JACKPOT_POSITION_TOP == "1" ? true : false;
  private authSubscription: Subscription;
  private showOtherGamesTitle;
  public loading: any;
  infiniteScrollThreshold: string = '15%'; // Default threshold
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  nextBatchSize: number;


  constructor(
    public webcontentService: WebcontentService,
    private config: ConfigService,
    private userSessionService: UserSessionService,
    private gameHubControllerService: GameHubControllerService,
    private navigator: Navigator,
    private eventsService: EventsService,
    private gamesService: GamesService,
    private lobbyStateService: LobbyStateService,
    private scroll: ScrollService,
    private readonly lobbyService: LobbyService,
    private readonly platform: Platform,
    private lobbyApiService: LobbyApiService,
    public loadingController: LoadingController,
    private readonly appLinksService: AppLinksService
  ) {
    this.showLDInFavTab = toBoolean(this.config.getConfig().FEATURE_LIVE_DEALER_FAVOURITE_TAB) ?? true;
    this.showSwimLanes = this.swimLanesSwitch();
  }

  ngOnInit() {
    this.autoLoadBatchTime = Number(this.config.getConfig().FEATURE_AUTOLOAD_BATCH_TIME) || 0;
    this.showOtherGamesTitle = this.config.getConfig().FEATURE_OTHER_GAMES_TITLE || "Other Games";
    this.nextBatchSize = stringToNumber(this.config.getConfig().FEATURE_LOBBY_NEXT_BATCH_SIZE) || 30;

    this.imagesPath = this.lobbyService.galleryImagePath;
    this.configReload();
    /*this.userSessionService
      .getCustomerSubscription()
      .then((subscription) => this.subscribeToCustomer(subscription));*/
    this.updateAuthentication();

    this.lobbyStateService.getCurrentKeywordSubject().subscribe((data) => {
      this.filteredCasinoGames = data?.gamesInfo;
      this.filteredCasinoGames = this.lobbyApiService.setDemoPlayFlag(this.filteredCasinoGames);
      if (this.filteredCasinoGames?.length) {
        this.autoLoadAllBatches(); // Automatically load more after first batch
      }
      this.selectedItem = data.keyword;
      if (this.isMobileApp && this.filteredCasinoGames) {
        this.mobileGameCounter = 1;
        this.allGamesLoaded = false;
        this.mobileCasinoGames = this.filteredCasinoGames.slice(
          0,
          this.mobileGamesSize
        );
      }
    });
    if (this.isMobileApp) {
      this.scroll.getScrollPosition().subscribe((element) => {
        if (element.detail.scrollTop > 300 * this.mobileGameCounter && !this.allGamesLoaded) {
          this.updateMobileCasinoGames();
          this.mobileGameCounter++;
        }
      });
    }
    this.eventsService.subscribe("event:freespin:loading:start", () => {
      this.showLoading();
    });
    this.eventsService.subscribe("event:freespin:loading:end", () => {
      this.hideLoading();
    });
  }

  async showLoading() {
    this.hideLoading();
    this.loading = await this.loadingController.create({
      message: "Loading...",
    });
    this.loading.present();
  }

  hideLoading() {
    try {
      this.loading.dismiss();
    } catch (e) {}
  }


  adjustPageSizeAndThreshold() {


    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    if (screenWidth < 768 && screenHeight < 1024) {
      // For small screens like phones in portrait mode
      this.pageSize = 16;
      this.infiniteScrollThreshold = '40%';
    } else if (screenWidth < 1024 && screenHeight < 1366) {
      // For tablets or phones in landscape mode
      this.pageSize = 20;
      this.infiniteScrollThreshold = '50%';
    } else if (screenWidth >= 1024 && screenHeight >= 1366) {
      // For larger screens, e.g., laptops/desktops
      this.pageSize = 30;
      this.infiniteScrollThreshold = '50%';
    } else {
      // Fallback for other device sizes or orientations
      this.pageSize = 24;
      this.infiniteScrollThreshold = '35%';
    }
  }

  // Automatically load all batches till the end of the list
  autoLoadAllBatches() {
    this.adjustPageSizeAndThreshold();
    const loadNextBatch = () => {
      if (this.pageSize < this.filteredCasinoGames.length) {
        // Programmatically trigger infinite scroll to load next batch
        this.doInfinite({ target: this.infiniteScroll }).then(() => {
          setTimeout(() => {
            loadNextBatch(); // Load next batch after current one is complete
          }, this.autoLoadBatchTime * 1000);
         
        });
      }
    };

    loadNextBatch(); // Start loading batches
  }

  configReload() {
    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        setTimeout(() => {
          this.imagesPath = this.lobbyService.galleryImagePath;
        }, 500);
      })
    });
  }

  subscribeToCustomer(subscription) {
    subscription.subscribe(() => {
      this.updateAuthentication();

    });
  }

  /*updateAuthentication() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
  }*/

  updateAuthentication() {
    // Subscribe to the authentication status observable
    this.authSubscription = this.userSessionService.getCustomer().subscribe((customer) => {
      this.isAuthenticated = !!customer;
    });
  }

  doInfinite(e) {
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        const nextBatchSize = this.pageSize + this.nextBatchSize;
        this.pageSize = Math.min(nextBatchSize, this.filteredCasinoGames.length);
        // If event is defined, call the complete function
        if (e && e.target && typeof e.target.complete === 'function') {
          e.target.complete(); // Complete the infinite scroll action
        }

        // Disable the infinite scroll if all games are loaded
        if (this.pageSize >= this.filteredCasinoGames.length) {
          if (e && e.target && typeof e.target.complete === 'function') {
            e.target.disabled = true;
          }
        }
        resolve();
      }, 0); // Simulate async loading
    });
  }

  increasePageSize() {
    this.pageSize = this.pageSize + this.pageSizeSet;
  }

  launchCasinoGame(gameData) {
    if (!this.isAuthenticated) {
      // save the gameData for later launch
      //this.LobbyService.setWaitingGameData(gameData);
      return this.openLoginModal(gameData);
    }

    return this.gameHubControllerService.launchCasinoGame(gameData);
  }


  onTileButton(gameData: any): any {
    if (gameData.externalLink?.url) {
      this.launchExternalLink(gameData);
      return;
    }
    if (!this.isAuthenticated) {
      this.lobbyService.setWaitingGameData(gameData);
      return this.openLoginModal(gameData);
    }
    this.gameHubControllerService.launchCasinoGame(gameData);
  }

  launchExternalLink(data) {
    const externalLink = data.externalLink;
    if (externalLink?.url) {
      const url = externalLink.url;
      if (externalLink.isExternalUrl) {
        this.appLinksService.openExternalPage(url);
      } else {
        if (externalLink.label === 'action_links') {
          if (this.isAuthenticated) {
            this.navigator.navigateTo(url, { multipleModals: true });
          } else {
            this.lobbyService.setWaitingDialogPage(url);
            this.navigator.navigateTo('LoginComponent');
          }
        } else {
          this.webcontentService.updateExternalLink(url);
          this.navigator.toTab('c', false, url);
        }
      }
    }
  }

  launchDemoPlay(gameData) {
    if (this.isAuthenticated) {
      return this.gameHubControllerService.launchCasinoGameDemo(gameData);
    }
    this.navigator.toAgeVerificationModal(gameData);
  }

  openLoginModal(gameData) {
    this.lobbyService.setWaitingGameData(gameData);
    return this.navigator.navigateTo("LoginComponent");
  }

  public onInfo(gamedata: any) {
    return this.navigator.navigateTo('GameDetailsComponent', { multipleModals: false }, { gamedata });
  }

  public checkForExternalLinks(url: string): any {
    const externalLinks = this.config.getExternalLinks().payload;
    const filteredExternalLink = externalLinks.filter(
      (link) => link.url == url
    )[0];
    return filteredExternalLink;
  }

  public getWPPageStub(name: string): string {
    const onlyAlphaNumeric = onlyAphaNumeric(name);
    const lowerCaseName = onlyAlphaNumeric.toLowerCase();
    const urlStub = spaceToHyphen(lowerCaseName);
    return urlStub;
  }

  public updateWpContent(link: any, page: string): any {
    const gameInfoErrorPage = this.config.getConfig().WP_GAME_INFO_ERROR_PAGE ?? "gameinfo_default";
    if (isUndefined(link) && !link) return this.webcontentService.updateExternalLink(gameInfoErrorPage);
    return this.webcontentService.updateExternalLink(page);
  }

  isFavourite(game_id) {
    if (!this.isAuthenticated) return false;
    return this.gamesService.isFavourite(game_id);
  }

  updateMobileCasinoGames() {
    if (!this.filteredCasinoGames) return;
    if (this.mobileCasinoGames.length < this.filteredCasinoGames.length) {
      this.mobileGamesSize = this.mobileGamesSize + 20;
      this.mobileCasinoGames = this.filteredCasinoGames.slice(
        0,
        this.mobileGamesSize
      );
    } else {
      this.mobileGamesSize = 20;
      this.allGamesLoaded = true;
    }
  }

  makeFavourite(gamedata, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.isAuthenticated) {
      this.navigator.navigateTo("LoginComponent");
      return;
    }

    this.gamesService.addFavouritesAndRecreate(gamedata);
    return;
  }

  makeUnFavourite(game_id, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.isAuthenticated) {
      this.navigator.navigateTo("LoginComponent");
      return;
    }

    this.gamesService.removeFavouritesAndRecreate(game_id);
    return;
  }

  getContentFromJSON(json) {
    if (!json) return;
    return JSON.parse(json);
  }

  private swimLanesSwitch(): boolean {
    const config = this.config.getConfig();
    const swimLanesConfig: boolean = toBoolean(config?.FEATURE_SWIM_LANES) ?? true;
    return swimLanesConfig;
  }

  public encodeImageSpaces(filename: string): string {
    return filename.replace(/ /g, '%20');
  }

  public getFullImageUrl(imagename: string): string {
    // Ensure imagesPath ends with a slash and concatenate with encoded filename
    const basePath = this.imagesPath.endsWith('/') ? this.imagesPath : this.imagesPath + '/';
    return basePath + this.encodeImageSpaces(imagename);
  }

  public getBackgroundImageStyle(gameData: any): string {
    if (!gameData?.imagename) return '';
    return `url('${this.getFullImageUrl(gameData.imagename)}')`;
  }
}
